<mat-select [tabIndex]="tabIndex" [formControl]="selectCtrl" [compareWith]="compareWith" disableOptionCentering
  (selectionChange)="onSelectionChange()" netFormChanged>
  <mat-option *ngIf="opportunityStatuses && opportunityStatuses.length === 0" disabled>
    {{'OPPORTUNITY.OPPORTUNITY_STATUS_NOT_FOUND' | translate}}</mat-option>
  <mat-option *ngFor="let status of opportunityStatuses" [value]="status.opportunityStatusId">
    {{ status.name }}
  </mat-option>
</mat-select>

<mat-progress-spinner *ngIf="loading === true" diameter="16" mode="indeterminate"></mat-progress-spinner>